/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from "react";
import "./styles.css";
import DashboardCard from "./component/DashboardCard";
import LinkCard from "./component/LinkCard";
import OrderChart from "./component/OrderChart";
import AddLink from "./component/AddLink";
// import { getStats } from "../../../actions/dashboard";
// import { useDispatch } from "react-redux";
import TopBarProgress from "react-topbar-progress-indicator";
import { useSelector } from "react-redux";

// Helper component for displaying user details
const UserProfileSummaryCard = ({ user }) => {
  if (!user) return null;

  // Destructure and select key fields for a professional summary
  const {
    fullName,
    userName,
    email,
    role,
    membershipType,
    rewardPoints,
    cashBack,
    verified,
    createdAt,
    reference,
  } = user;

  const creationDate = new Date(createdAt).toLocaleDateString();

  return (
    <div className="user-profile-summary-card">
      <h3 className="font-weight-bold mb-4">👑 User Profile Overview</h3>
      <div className="profile-details-grid">
        <div className="detail-item">
          <strong>Full Name:</strong>
          <span>{fullName}</span>
        </div>
        <div className="detail-item">
          <strong>Username:</strong>
          <span>@{userName}</span>
        </div>
        <div className="detail-item">
          <strong>Email:</strong>
          <span>{email}</span>
        </div>
        <div className="detail-item">
          <strong>Account Role:</strong>
          <span>{role?.toUpperCase()}</span>
        </div>
        <div className="detail-item">
          <strong>Joined On:</strong>
          <span>{creationDate}</span>
        </div>
  
      </div>
    </div>
  );
};

const HomeDashboard = () => {
  //   const dispatch = useDispatch();
  const user = useSelector((state) => state?.auth?.user); // Renamed userRole to user for clarity
  console.log("auth", user);

  const [addLinks, setaddLinks] = useState(
    JSON.parse(localStorage?.getItem("addLink")) || []
  );

  const [loading, setloading] = useState(false);

  useEffect(() => {
    // getDashboardStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? (
        <TopBarProgress />
      ) : (
        <div className="dashboard-content-container">
          {/* --- User Profile Summary Section --- */}
          <UserProfileSummaryCard user={user} />
          {/* ------------------------------------- */}

          <div className="quick-link">
            <h3 className=" font-weight-bold mt-5">Quick Links</h3>
            <div className="link-card-container">
              {/* {QuickLink.map((item, index)=>(
              <LinkCard key={index} name={item.title} link={item.link} />

            ))} */}
              {addLinks?.map((item, index) => (
                <LinkCard
                  key={index}
                  i={index}
                  name={item.title}
                  link={item.link}
                  setaddLinks={setaddLinks}
                />
              ))}
              <AddLink name="+ Add Link" setaddLinks={setaddLinks} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HomeDashboard;